import { Box, Grid, Image, Text } from '@chakra-ui/react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'

export function HeaderInfo({ numeroNota, dataPedido }) {
  const dataAtual = new Date()
  const dataFormatada = format(
    dataAtual,
    "'São Paulo, 'd 'de' MMMM 'de' yyyy",
    { locale: ptBR }
  )

  return (
    <Grid templateColumns="repeat(12, 1fr)" gap={4}>
      <Box
        gridColumn={{
          base: 'span 12',
          md: 'span 8',
        }}
        display="flex"
        alignItems="center"
      >
        <Image
          src="https://imgproductioncrm.s3.us-east-2.amazonaws.com/logo%20desk.svg"
          fallbackSrc="https://via.placeholder.com/120"
          alt="Logo"
          height="60px"
          width="auto"
          objectFit="contain"
        />
        <Text
          bg="#7fb603"
          mx="auto"
          w="full"
          textAlign="center"
          fontSize="20px"
          color="white"
        >
          {dataFormatada}
        </Text>
      </Box>
      <Box
        gridColumn={{
          base: 'span 12',
          md: 'span 4',
        }}
        my="auto"
      >
        Pedido de compra:{' '}
        <b>
          #{dataPedido.numero_pedido}/{numeroNota}
        </b>
      </Box>
    </Grid>
  )
}
